import { useState, memo } from 'react';

function RangeIndicator({ level, maxLevel = 3, labels = ['Niedrig', 'Mittel', 'Hoch'], tooltip, showLabelsBelow = true }) {
  const [showTooltip, setShowTooltip] = useState(false);
  
  return (
    <div className="relative">
      <div className="flex items-center mt-1 mb-1">
        <div className="flex-grow">
          <div className="flex">
            {Array.from({ length: maxLevel }).map((_, index) => (
              <div 
                key={index} 
                className={`h-3 w-full border-r-2 border-white relative ${index < level ? 'bg-blue-500' : 'bg-gray-200'}`}
                style={{ borderTopLeftRadius: index === 0 ? '4px' : '0', 
                         borderBottomLeftRadius: index === 0 ? '4px' : '0', 
                         borderTopRightRadius: index === maxLevel - 1 ? '4px' : '0', 
                         borderBottomRightRadius: index === maxLevel - 1 ? '4px' : '0' }}
              >
                {/* Active indicator dot */}
                {index === level - 1 && (
                  <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-5 h-5 bg-blue-600 rounded-full border-2 border-white shadow-sm"></div>
                )}
              </div>
            ))}
          </div>
          
          {/* Labels below the bar */}
          {showLabelsBelow && (
            <div className="flex justify-between mt-1">
              {labels.map((label, idx) => (
                <div 
                  key={idx} 
                  className={`text-xs ${idx === level - 1 ? 'text-blue-600 font-medium' : 'text-gray-500'}`}
                  style={{ 
                    width: `${100 / labels.length}%`,
                    textAlign: idx === 0 ? 'left' : idx === labels.length - 1 ? 'right' : 'center'
                  }}
                >
                  {label}
                </div>
              ))}
            </div>
          )}
        </div>
        
        {tooltip && (
          <button
            className="ml-2 text-gray-400 hover:text-gray-600"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </button>
        )}
      </div>
      {showTooltip && tooltip && (
        <div className="absolute z-10 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg max-w-xs -top-2 left-full ml-2">
          <div className="font-semibold mb-1">{tooltip.title}</div>
          {tooltip.items.map((item, idx) => (
            <div key={idx} className="mb-1">
              <span className="font-medium">{item.label}:</span> {item.description}
            </div>
          ))}
          <div className="absolute top-4 -left-2 w-0 h-0 border-t-8 border-t-transparent border-r-8 border-r-gray-900 border-b-8 border-b-transparent"></div>
        </div>
      )}
    </div>
  );
}

export default memo(RangeIndicator);